import { Dispatch } from "redux";
import { loadAndTrack } from "redux-request-loading";

import { ppq } from "@teamprevent/common";

import { Payload } from "@neworbit/redux-helpers";

import { OhCaseDetailModel } from "../crud/ohCase";

import { TasksUpdatedSuccessResult } from "../task/model";

import { ppqReportApi } from "./PpqReportApi";
import * as actions from "./actionTypes";

export type PpqReportAction =
    ApprovePpqCertificateSuccess |
    RequestChangesPpqCertificateSuccess |
    RejectPpqCertificateSuccess |
    SendToEmployeeForConsentPpqCertificateSuccess;

export type LoadPpqReportSuccess = ({ type: typeof actions.LOAD_PPQ_REPORT_SUCCESS }) & Payload<ppq.PpqReportModel>;
export type ApprovePpqCertificateSuccess = ({ type: typeof actions.APPROVE_PPQ_CERTIFICATE_SUCCESS }) & Payload<OhCaseDetailModel>;
export type RequestChangesPpqCertificateSuccess = ({ type: typeof actions.REQUEST_CHANGES_PPQ_CERTIFICATE_SUCCESS }) & Payload<TasksUpdatedSuccessResult>;
export type RejectPpqCertificateSuccess = ({ type: typeof actions.REJECT_PPQ_CERTIFICATE_SUCCESS }) & Payload<TasksUpdatedSuccessResult>;
export type SendToEmployeeForConsentPpqCertificateSuccess = ({ type: typeof actions.SENDTOEMPLOYEE_PPQ_CERTIFICATE_SUCCESS }) & Payload<OhCaseDetailModel>;
export type PpqAction = LoadPpqReportSuccess;

export const buildLoadPpqReport = () => {
    return ({ ohCaseId, viewReportTaskId }: { ohCaseId: string; viewReportTaskId: string }) => {
        return async (dispatch: Dispatch) => {
            const response = await loadAndTrack(dispatch, actions.LOAD_PPQ_REPORT, ppqReportApi.loadPpqReport(ohCaseId, viewReportTaskId));
            dispatch(loadPpqReportSuccess(response));
        };
    };
};

export const loadPpqReport = buildLoadPpqReport();

export const loadPpqReportSuccess = (ppqReport: ppq.PpqReportModel): PpqAction => {
    return {
        type: actions.LOAD_PPQ_REPORT_SUCCESS,
        payload: ppqReport
    };
};

export const approvePpqCertificate = (ohCaseId: string, taskId: string, notes: string) => {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.APPROVE_PPQ_CERTIFICATE, ppqReportApi.approve(ohCaseId, taskId, notes));
        dispatch(approvePpqCertificateSuccess(result));
    };
};

export const rejectPpqCertificate = (ohCaseId: string, taskId: string, notes: string) => {
    return async (dispatch: Dispatch) => {
        const results = await loadAndTrack(dispatch, actions.REJECT_PPQ_CERTIFICATE, ppqReportApi.reject(ohCaseId, taskId, notes));
        dispatch(rejectPpqCertificateSuccess({ ohCaseId, tasks: results }));
    };
};

export const requestChangesPpqCertificate = (ohCaseId: string, taskId: string, notes: string) => {
    return async (dispatch: Dispatch) => {
        const results =
            await loadAndTrack(dispatch, actions.REQUEST_CHANGES_PPQ_CERTIFICATE, ppqReportApi.requestChanges(ohCaseId, taskId, notes));
        dispatch(requestChangesPpqCertificateSuccess({ ohCaseId, tasks: results }));
    };
};

export const sendToEmployeeForConsentPpqCertificate = (ohCaseId: string, taskId: string, notes: string) => {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(
            dispatch,
            actions.SENDTOEMPLOYEE_PPQ_CERTIFICATE, ppqReportApi.sendToEmployeeForConsent(ohCaseId, taskId, notes));
        dispatch(sendToEmployeeForConsentPpqCertificateSuccess(result));
    };
};

export const approvePpqCertificateSuccess = (payload: OhCaseDetailModel): ApprovePpqCertificateSuccess => {
    return {
        type: actions.APPROVE_PPQ_CERTIFICATE_SUCCESS,
        payload
    };
};

export const rejectPpqCertificateSuccess = (payload: TasksUpdatedSuccessResult): RejectPpqCertificateSuccess => {
    return {
        type: actions.REJECT_PPQ_CERTIFICATE_SUCCESS,
        payload
    };
};

export const requestChangesPpqCertificateSuccess = (payload: TasksUpdatedSuccessResult): RequestChangesPpqCertificateSuccess => {
    return {
        type: actions.REQUEST_CHANGES_PPQ_CERTIFICATE_SUCCESS,
        payload
    };
};

export const sendToEmployeeForConsentPpqCertificateSuccess = (payload: OhCaseDetailModel): SendToEmployeeForConsentPpqCertificateSuccess => {
    return {
        type: actions.SENDTOEMPLOYEE_PPQ_CERTIFICATE_SUCCESS,
        payload
    };
};
